import { RootState } from "app/store";
import CreationDescription from "../../../../../../components/creation/CreationDescription";
import Error500 from "../../../../../../components/errors/Error500";
import TotalResult from "../../../../../../components/panel/TotalResult";
import { Creation } from "../../../../../../utils-creation/types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initList, loadMore, getCreationYearsStats } from "./creationTabSlice";
import { Button, List, Select, Skeleton } from "antd";
import CreationTitle from "../../../../../../components/creation/CreationTitle";
import searchPageUserInputS from "../../../UserInputsSlice";
import { SearchTab } from "utils/types";

export default function CreationTab() {
  const dispatch = useDispatch();

  const {
    keywordType,
    searchInput,
    facultyID,
    departmentID,
    searchTab,
    creationSpecific: { year: selectedYear },
  } = useSelector((state: RootState) => state.searchPgUserInputs);

  const {
    creationsList,
    status,
    total,
    hasNext,
    yearFilter: { years, total: total_yearFilter, status: status_yearFilter },
  } = useSelector((state: RootState) => state.creationTab);

  useEffect(() => {
    searchTab === SearchTab.RESEARCH_CREATION && dispatch(
      initList({
        keywordType,
        searchInput,
        facultyID,
        departmentID,
        year: selectedYear,
      })
    );
  }, [
    dispatch,
    keywordType,
    searchInput,
    facultyID,
    departmentID,
    selectedYear,
    searchTab,
  ]);

  useEffect(() => {
    dispatch(
      getCreationYearsStats({
        keywordType,
        searchInput,
        facultyID,
        departmentID,
      })
    );
  }, [dispatch, keywordType, searchInput, facultyID, departmentID]);

  return (
    <>
      {total >= 0 && <TotalResult searchResult={total} />}

      {total_yearFilter >= 0 && (
        <Select
          className="sub-heading-font"
          value={selectedYear}
          style={{ width: 200, marginRight: 8, marginBottom: 4 }}
          onChange={(value) => {
            dispatch(searchPageUserInputS.actions.setCreationYear(value));
          }}
          loading={status_yearFilter !== "succeeded"}
          disabled={status_yearFilter !== "succeeded"}
          filterOption={(input, option) =>
            option !== undefined &&
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {[
            <Select.Option className="sub-heading-font" value={-1} key={-1}>
              {`All premiere years (${total_yearFilter})`}
            </Select.Option>,
            ...years.map((x) => (
              <Select.Option
                className="sub-heading-font"
                value={x.year}
                key={x.year}
              >
                {`${x.year} (${x.count})`}
              </Select.Option>
            )),
          ]}
        </Select>
      )}

      {status !== "failed" && (
        <List
          loading={status === "idle"}
          itemLayout="horizontal"
          loadMore={
            hasNext ? (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 12,
                  height: 32,
                  lineHeight: "32px",
                }}
              >
                <Button
                  className="sub-heading-font"
                  onClick={() => dispatch(loadMore())}
                >
                  More
                </Button>
              </div>
            ) : null
          }
          dataSource={creationsList}
          renderItem={(item) => {
            const creation = item.item as Creation;
            return (
              <List.Item>
                <Skeleton title={false} loading={item.loading} active>
                  <List.Item.Meta
                    title={<CreationTitle creation={creation} />}
                    description={<CreationDescription creation={creation} />}
                  />
                </Skeleton>
              </List.Item>
            );
          }}
        />
      )}

      {status === "failed" && <Error500 />}
    </>
  );
}
